<template>
    <rkm-overlay>
        <rkm-layout-body title="Alterar horário de saída">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="handleSave"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List
                    ref="List"
                    @save="handleSave"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/alterar-horario/List'

export default {
    components: { List },
    methods: {
        handleExit() {
            this.$router.push({ name: 'dashboard' })
        },
        handleSave() {
            this.$refs.List.save()
        },
    },
}
</script>